module.exports = __webpack_public_path__ + "img/product-cta.8b18786c.jpeg";